import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const linksMap = {
  'suit-and-tuxedo': (
    <Link href="/collection/tuxedos-and-suits" className="tracker-text-vests_tux_and_suits-230525-133337">
      {'suit and tuxedo'}
    </Link>
  ),
  'suit-vests': (
    <Link href="/collection/vests-and-cummerbunds?type=Vest" className="tracker-text-vests_suit_vests-230525-133339">
      {'Suit vests'}
    </Link>
  ),
  cummerbund: (
    <Link href="/collection/vests-and-cummerbunds?type=Cummerbund" className="tracker-text-vests_cummerbund-230525-133340">
      {'cummerbund'}
    </Link>
  ),
};

const VestsAndCummerbundsCopy = () => (
  <Layout1x1>
    <h3 data-testid="vests-title" className="text-h2">
      {'Vest and Cummerbunds | Accessory Collection'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="vests-desc" className="!mb-64 text-gray-darker">
      It all comes down to the details. And by details, we mean the perfect {linksMap['suit-and-tuxedo']} accessories like vests and
      cummerbunds. Whether you dress to impress or simply want to add a touch of color to a festive evening, at Menguin we have the perfect
      options for you.
    </p>

    <h3 data-testid="vests-title" className="text-h2">
      {'Men’s Suit Vests'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="vests-desc" className="!mb-64 text-gray-darker">
      Take your suit and turn it into a three-piece affair by adding a stylish suit vest. {linksMap['suit-vests']} add an extra layer of
      sophistication to your outfit so you can stand out from the crowd. For chillier months, a suit vest also helps keep you warm – perfect
      for those outdoor dinners and celebrations. Match your suit vest to your tie for a pop of color and personality. Choose from classic
      plaid or paisley prints, or opt for any solid color of your choice.
    </p>

    <h3 data-testid="vests-title" className="text-h2">
      {'Tuxedo Cummerbund'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="vests-desc" className="text-gray-darker">
      What exactly is a cummerbund, you may ask? A {linksMap.cummerbund} is a board waist sash that is worn with a tuxedo. This classic
      tuxedo accessory dates back hundreds of years, but remains a stylish essential to this day. A tuxedo cummerbund usually has a
      multi-pleat design and can come in a variety of colors and prints. You can pair your cummerbund to your bow tie so you can look
      polished all evening long.
    </p>
  </Layout1x1>
);

export default VestsAndCummerbundsCopy;
